
import {mapGetters} from 'vuex';
import {ScreenOrientation} from '@capacitor/screen-orientation';
import {Player, Vimeo, Video, DefaultUi} from '@vime/vue';
import programQuery from '~/graphql/queries/radio/program.gql';
import videoQuery from '~/graphql/queries/video/video.gql';
import carouselProgramsQuery from '~/graphql/queries/radio/carouselPrograms.gql';

export default {
  auth: false,
  components: {Player, Vimeo, Video, DefaultUi},
  apollo: {
    program: {
      query: programQuery,
      variables() {
        return {
          slug: this.$route?.params?.slug,
        };
      },
    },
    programs: {
      query: carouselProgramsQuery,
      variables() {
        return {
          notSlug: this.$route?.params?.slug,
        };
      },
    },
    video: {
      query: videoQuery,
      variables() {
        return {
          slug: this.$route?.params?.video,
        };
      },
      result({data: {video}}) {
        if (!video) {
          return this.$nuxt.error({statusCode: 404, message: 'Pagina niet gevonden'});
        }
      },
    },
  },
  data: vm => ({
    program: {},
    programs: [],
    video: null,
    videoElement: null,
  }),
  computed: {
    ...mapGetters([
      'isSubscriber',
    ]),
    videoFile() {
      return this.video?.file?.[0];
    },
  },
  watch: {
    video() {
      this.$nextTick(() => {
        this.videoElement = document.querySelector('#videoFrame');

        if (this.videoElement) {
          this.videoElement.addEventListener('fullscreenchange', this.handleFullScreenChange);
        }
      });
    },
  },
  beforeDestroy() {
    if (this.videoElement) {
      this.videoElement.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    }
  },
  methods: {
    handleFullScreenChange(isFullScreen) {
      if (typeof isFullScreen !== 'boolean' && this.videoElement) {
        isFullScreen = document.fullscreenElement === this.videoElement;
      }

      if (this.isNativePlatform) {
        if (isFullScreen) {
          ScreenOrientation.unlock();
        } else {
          ScreenOrientation.lock({
            orientation: 'portrait',
          });
        }
      }
    },
  },
};
